import React, { PureComponent } from 'react';
import { Button, Form, InputNumber, Radio, Slider } from 'antd';
import { services } from '@comall-backend-builder/core';
import { language } from '../../../language';
import { EntryList, FormItemLayout, ConfigFormDecorator } from '../../tools';
import DetailTitle from '../../DetailTitle';
import { ImageAdItem } from './ImageAdItem';
import { ImageAdTips } from './ImageAdTips';
import './index.less';
import { DESIGN_PAGE_LINK_TYPES_HOT_LIST } from '../../../../constants/page-design';

const FormItem = Form.Item;
const RadioGroup = Radio.Group;

const MAX_ENTRY_COUNT = 10;
const interpolate = services.interpolate;
/**
 * 图文组件-配置表单
 */

/**
 * 图文组件-配置表单
 */

const templates = [
    {
        id: '1',
        name: '样式一',
    },
    {
        id: '2',
        name: '样式二',
    },
    {
        id: '3',
        name: '样式三',
    },
    {
        id: '4',
        name: '样式四',
    },
    {
        id: '5',
        name: '样式五',
    },
];

/**
 * 拥有背景的模板
 */
const haveBackgroundTemplate = ['2', '3', '4'];

class BannerCom extends PureComponent<any> {
    state = {
        templateId: this.props.value.showStyle || '1',
    };

    WrapImageAdItem = (props: any) => {
        const { uploadAction, selector, sourceRoot } = this.props;
        return (
            <ImageAdItem
                {...props}
                sourceRoot={sourceRoot}
                selector={selector}
                uploadAction={uploadAction}
                showDescribe={this.props.value.showStyle === '5'}
            />
        );
    };
    handleClickTemplates = (id: string) => {
        const { form, onChange } = this.props;
        const formValue = form.getFieldsValue();

        this.setState(
            {
                templateId: id,
            },
            () => onChange({ ...formValue, showStyle: id })
        );
    };
    render() {
        const {
            form: { getFieldDecorator },
            linkTypes,
            linkTypeMode,
            value,
        } = this.props;
        const formItemLayout = FormItemLayout;
        const { templateId } = this.state;
        const isFill = value.fillStyle === '2';
        return (
            <Form className="editor-image-ad">
                <FormItem {...formItemLayout} label="轮播样式">
                    {[
                        getFieldDecorator('showStyle', {}),
                        templates.map((item) => (
                            <Button
                                type={templateId === item.id ? 'primary' : 'default'}
                                shape="round"
                                style={{ marginRight: '16px' }}
                                key={item.id}
                                onClick={() => this.handleClickTemplates(item.id)}
                            >
                                {item.name}
                            </Button>
                        )),
                    ]}
                </FormItem>
                {haveBackgroundTemplate.includes(templateId) ? (
                    <>
                        <DetailTitle label={`背景设置`} />
                        <FormItem>
                            {getFieldDecorator('backgroundImage', {
                                initialValue: [],
                            })(
                                <EntryList
                                    linkTypes={linkTypes}
                                    linkTypeMode={linkTypeMode}
                                    maxCount={1}
                                    renderItem={this.WrapImageAdItem}
                                    renderTips={ImageAdTips}
                                    showModule={true}
                                />
                            )}
                        </FormItem>
                    </>
                ) : (
                    ''
                )}

                <FormItem {...formItemLayout} label="填充方式">
                    {getFieldDecorator(
                        'fillStyle',
                        {}
                    )(
                        <RadioGroup className="fill-style">
                            <Radio value={'1'}>
                                {language.getText('components.ImageAd.blank')}
                            </Radio>
                            <Radio value={'2'}>{language.getText('components.ImageAd.fill')}</Radio>
                        </RadioGroup>
                    )}
                </FormItem>
                {/* 
                {isFill && (
                    <FormItem {...formItemLayout} label={'图片高度'}>
                        {getFieldDecorator('imageHeight')(<Slider max={550} min={200} />)}
                    </FormItem>
                )} */}

                {!isFill && (
                    <FormItem {...formItemLayout} label="页面边距">
                        {getFieldDecorator('margin')(<Slider max={48} min={0} />)}
                    </FormItem>
                )}

                {haveBackgroundTemplate.includes(templateId) ? (
                    <>
                        <FormItem {...formItemLayout} label="图片圆角">
                            {getFieldDecorator('bgBorderRadius')(<Slider max={48} min={0} />)}
                        </FormItem>
                        <DetailTitle label={`轮播图设置`} />
                        <FormItem
                            className="inputNumberStyle"
                            {...formItemLayout}
                            label="轮播图位置"
                        >
                            {getFieldDecorator('bannerMarinTop')(
                                <InputNumber min={0} max={2000} />
                            )}
                        </FormItem>
                    </>
                ) : (
                    ''
                )}
                <FormItem {...formItemLayout} label="图片圆角">
                    {getFieldDecorator('borderRadius')(<Slider max={48} min={0} />)}
                </FormItem>
                <FormItem>
                    {getFieldDecorator('entry', {
                        initialValue: [],
                    })(
                        <EntryList
                            linkTypes={DESIGN_PAGE_LINK_TYPES_HOT_LIST}
                            linkTypeMode={linkTypeMode}
                            maxCount={MAX_ENTRY_COUNT}
                            renderItem={this.WrapImageAdItem}
                            renderTips={ImageAdTips}
                        />
                    )}
                </FormItem>
                <p className="entry-tip">
                    {interpolate(language.getText('components.ImageAd.tips'), {
                        max: MAX_ENTRY_COUNT,
                    })}
                </p>
            </Form>
        );
    }
}

export const Banner = ConfigFormDecorator(BannerCom);
